import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// Assuming you set your logo text in an environment variable
const LOGO_TEXT = process.env.REACT_APP_LOGO_TEXT || '';

// Updated size map for a cleaner fit
const sizeMap = {
  small: { height: 32, textSize: '0.9rem' },
  medium: { height: 42, textSize: '1.2rem' },
  large: { height: 50, textSize: '1.4rem' },
};

const LogoSection = ({
  variant = 'default',
  size = 'medium',
  showText = true,
  showImage = true,
  linkTo = '/',
  // Replace with your actual refined logo image path
  src = '/logo.jpg', 
  sx = {},
  imageSx = {},
  textSx = {},
  component: Component = RouterLink,
  ...rest
}) => {
  const dimensions = sizeMap[size] || sizeMap.medium;

  const getTextStyles = () => {
    if (variant === 'white') {
      return {
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: '0.5px',
      };
    }
    if (variant === 'admin') {
      return {
        color: '#1A3365', // Elegant solid deep blue for admin
        fontWeight: 700,
        letterSpacing: '-0.5px',
      };
    }
    // Default case: Sophisticated professional gradient
    return {
      fontWeight: 800,
      background: 'linear-gradient(90deg, #D4AF37 0%, #E2C56A 45%, #f5ff83 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      letterSpacing: '0.04em',
    };
  };

  const isWhiteVariant = variant === 'white' || variant === 'admin';
  const effectiveImageSx = {
    ...(isWhiteVariant && {
      filter: 'brightness(0) invert(1)',
    }),
    ...imageSx,
  };

  return (
    <Box
      component={Component}
      to={linkTo}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        gap: 1.5,
        ...sx,
      }}
      {...rest}
    >
      {showImage && (
        <Box
          component="img"
          src={src}
          alt="Travel Agency Logo"
          sx={{
            height: dimensions.height,
            width: 'auto',
            maxWidth: 170,
            objectFit: 'contain',
            borderRadius: 1,
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.02)',
            },
            ...effectiveImageSx,
          }}
        />
      )}
      {showText && LOGO_TEXT && (
        <Typography
          variant={size === 'small' ? 'subtitle1' : 'h5'}
          sx={{
            fontSize: dimensions.textSize,
            whiteSpace: 'nowrap',
            ...getTextStyles(),
            ...textSx,
          }}
        >
          {LOGO_TEXT}
        </Typography>
      )}
    </Box>
  );
};

export default LogoSection;